<template>
    <router-link :to="url" class="nav-link">
        <i :class="icon"></i> {{name}}
        <b-badge :variant="badge.variant">{{badge.text}}</b-badge>
    </router-link>
</template>

<script>
  export default {
      name: 'sidebar-nav-link',
      props: {
          name: {
              type: String,
              default: ''
          },
          url: {
              type: [String, Object],
              default: ''
          },
          icon: {
              type: String,
              default: ''
          },
          badge: {
              default: ''
          }
      },
      mounted () {},
      computed: {
          confirm () {
              console.log(typeof this.url)
          }
      }
  }
</script>



// WEBPACK FOOTER //
// SidebarNavLink.vue?ac48572e